var React = require('react');

function SbCross (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"#B2B2B2","d":"M32 0C14.356 0 0 14.356 0 32s14.356 32 32 32 32-14.356 32-32S49.644 0 32 0zm0 61.536C15.715 61.536 2.464 48.285 2.464 32 2.464 15.715 15.715 2.464 32 2.464c16.285 0 29.536 13.25 29.536 29.536C61.535 48.285 48.285 61.536 32 61.536zm0 0","key":0}),React.createElement("path",{"fill":"#B2B2B2","d":"M49.232 33.891H14.769a1.888 1.888 0 110-3.778h34.463a1.888 1.888 0 110 3.778z","key":1})]);
}

SbCross.defaultProps = {"width":"64","height":"64","viewBox":"0 0 64 64"};

module.exports = SbCross;

SbCross.default = SbCross;
